import myImage1 from "../assets/New Construction Framing.png";
import myImage2 from "../assets/Custom Home Framing.png";
import myImage3 from "../assets/Room Additions & ADU Framing.png";
import myImage4 from "../assets/Commercial Framing.jpg";
import myImage5 from "../assets/Roof, Wall & Floor Framing.jpg";
import myImage6 from "../assets/Structural Repairs & Reinforcement.png";

export const slides = [
    {
        title: "New Construction Framing",
        description: "Framing for new residential and commercial builds, including floors, walls, and roofs.",
        backgroundImage: myImage1,
    },
    {
        title: "Custom Home Framing",
        description: "Professional framing for custom homes, luxury builds, and detailed architectural designs.",
        backgroundImage: myImage2,
    },
    {
        title: "Room Additions & ADU Framing",
        description: "Framing for home additions, second stories, and ADUs, built to match existing structures.",
        backgroundImage: myImage3,
    },
    {
        title: "Commercial Framing",
        description: "Durable framing for offices, retail spaces, and multi-unit buildings.",
        backgroundImage: myImage4,
    },
    {
        title: "Roof, Wall & Floor Framing",
        description: "Full structural systems including joists, rafters, trusses, and load-bearing walls.",
        backgroundImage: myImage5,
    },
    {
        title: "Structural Repairs & Reinforcement",
        description: "Framing repairs, beam installs, and structural upgrades for safety and stability.",
        backgroundImage: myImage6,
    },
];
